import { Component, OnInit, Input } from '@angular/core';
import {
  InvoiceItems,
  ManualInvoice,
  CustomInvoiceFieldValue,
  ManualInvoicePartialPaySetting,
} from '../../models/invoice.model';
import { Settings } from '../../../shared/models/settings/settings.model';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-invoice-template-2',
  templateUrl: './invoice-template-2-component.html',
  styleUrls: ['./invoice-template-2-component.scss'],
})
export class InvoiceTemplate2Component implements OnInit {
  @Input() invoiceTemplateModel: any = null;
  @Input() invoiceItems: InvoiceItems[];
  @Input() manualInvoice: ManualInvoice;
  @Input() customerInfo: any;
  @Input() assigndEmployees: any[] = [];
  @Input() grossTotal: number;
  @Input() totalInvoiceAmount: number;
  @Input() totalDeposits: number;
  @Input() tipAmt: number = 0;
  @Input() displayTipAmt: boolean = true;
  @Input() businessInfo: Settings;
  @Input() locationData: any;
  @Input() customFieldValues: CustomInvoiceFieldValue[] = [];
  @Input() customerAddress: string = '';
  @Input() manualInvoicePayments: any = [];
  @Input() partialPayment: ManualInvoicePartialPaySetting;
  businessLogoUrl: string = 'assets/images/grey-square.png';
  public backgroundImg: SafeStyle;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.businessLogoUrl = this.businessInfo.Logo
      ? this.businessInfo.Logo
      : 'assets/images/grey-square.png';

    this.backgroundImg = this.sanitizer.bypassSecurityTrustStyle(
      'url(' + this.businessLogoUrl + ')'
    );
  }

  getPartialAmountDue(): number {
    let amount;

    if (this.partialPayment && this.partialPayment.partialDueType === '%') {
      amount =
        (this.manualInvoice.Balance * this.partialPayment.partialDue) / 100;
    } else {
      amount = this.partialPayment.partialDue;
    }

    return amount;
  }

  getL2L3Description(item): boolean {
    return item.TaxAmount || item. TaxType || item.ProductCode || item.ItemCommodityCode || item. UnitOfMeasure || item.DiscountAmount || item.TaxTreatment;
  }
}
